






























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import AppSwitch from '@/views/kyc-form/component/AppSwitch.vue'
import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import CashFlow from '@company-common/model/kyc-form/finances/JParaCashFlow'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppSwitch,
    AppRadioSelection,
    AppForm
  }
})
export default class CashFlowView extends Vue {
  selectedClient = 'Client 1';

  @kycFormStore.State
  private kycForm!: KYCForm;

  @kycFormStore.State
  private computedValidationResult: any

  get sectionErrors () {
    return this.computedValidationResult['Cash Flow'] || {}
  }

  get cashFlowSectionErrors () {
    const errors = this.sectionErrors[this.selectedClient] || []
    const finalErrors: { key: string; msg: string }[] = []
    errors.map(({ key, message }) => {
      key.map(variableName => {
        finalErrors.push({
          key: variableName,
          msg: message
        })
      })
    })
    return finalErrors
  }

  get sharedCashFlowAttributes () {
    return this.kycForm.client1.cashFlow
  }

  get editingClient () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1.cashFlow
    } else {
      return this.kycForm.client2.cashFlow
    }
  }

  clientOptionSelected (option: string): void {
    if (option === 'Client 2' && !this.isClient2Included()) {
      window.alert(
        'Client 2 is not included in this KYC Form. To include, go to "Client Summary" page and enable the checkbox.'
      )
      return
    }
    this.selectedClient = option
  }

  isClient2Included () {
    return this.kycForm.client2.personalDetails.included
  }

  @Watch('sharedCashFlowAttributes.cashFlowPlanning')
  planningChanged (newValue: string) {
    if (newValue === 'yes') {
      this.sharedCashFlowAttributes.cashFlowPlanningReasons = ''
    }
  }

  @Watch('editingClient.cashFlowChanges')
  cashFlowChanged (newValue: string) {
    if (newValue === 'no') {
      this.editingClient.cashFlowChangesReasons = ''
    }
  }

  get cashFlowIncomeStructure (): FormStructure<CashFlow> {
    return [
      {
        label: 'Employment (less CPF)',
        key: 'employment',
        type: 'currency'
      }, {
        label: 'Business',
        key: 'business',
        type: 'currency'
      }, {
        label: 'Investment Income',
        key: 'investmentIncome',
        type: 'currency'
      }, {
        label: 'Dividends',
        key: 'dividends',
        type: 'currency'
      }, {
        label: 'Rental Income',
        key: 'rentalIncome',
        type: 'currency'
      }, {
        label: 'Click to add income source',
        labelModel: {
          get: () => this.sharedCashFlowAttributes.others10Text,
          set: (value) => { this.sharedCashFlowAttributes.others10Text = value as string }
        },
        key: 'others10',
        type: 'currency'
      }, {
        label: 'Click to add income source',
        labelModel: {
          get: () => this.sharedCashFlowAttributes.others11Text,
          set: (value) => { this.sharedCashFlowAttributes.others11Text = value as string }
        },
        key: 'others11',
        type: 'currency'
      }
    ]
  }

  get cashFlowExpensesStructure (): FormStructure<CashFlow> {
    return [
      {
        label: 'Mortgage Loan',
        key: 'mortgageLoan',
        type: 'currency'
      }, {
        label: 'Car/Other Loans',
        key: 'carLoan',
        type: 'currency'
      }, {
        label: 'Insurance Premiums',
        key: 'insurancePremiums',
        type: 'currency'
      }, {
        label: 'Savings (FD/Investments)',
        key: 'regularSavings',
        type: 'currency'
      }, {
        label: 'Family (Dependents/ Groceries/ Utilities/ etc.)',
        key: 'parentalSupport',
        type: 'currency'
      }, {
        label: 'Personal (Grooming/ Clothing/ Transportation/ etc.)',
        key: 'personalExpenses',
        type: 'currency'
      }, {
        label: 'Lifestyle (Entertainment/ Vacation/ Country Clubs/ etc.)',
        key: 'lifestyleExpenses',
        type: 'currency'
      }, {
        label: 'Click to add expense',
        labelModel: {
          get: () => this.sharedCashFlowAttributes.others12Text,
          set: (value) => { this.sharedCashFlowAttributes.others12Text = value as string }
        },
        key: 'others12',
        type: 'currency'
      }
    ]
  }
}
